/**
 * State for add new
 */
export const state = {
  firstName: "", // First name
  lastName: "", // Last name
  pha_line1: "", // Line 1 of the address
  pha_line2: "", // Line 2 of the address
  pha_city: "", // City
  pha_state: 0, // State code
  pha_postalCode: "", // Postal code
  /**
   * Birthdate object
   */
  birthDate: {
    dayOfMonth: 0,
    month: 0,
    year: 0
  },
  phone: [], // Phone number
  phoneType: [0, 0, 0, 0], // Phone type
  allPhoneTypes: ["cell", "home", "work", "fax", "other"],
  email: [], // Email
  submitted: false, // If form has been submitted or not
  loading: 0, // If something is loading, set this to true form loader
  timezone: {
    list: [], // The list of timezones
    selected: "" // The selected option
  },
  stateCodes: [], // All the state codes
  insuranceCompanies: {}, // The insurance companies
  selectedInsuranceValue: 0, // The selected insurance company
  insuranceType: "primary", // Insurance type
  insuranceId: "", // The insurance id
  notes: "" // The notes
};
